import React from 'react';
import { Route } from 'react-router';
import DhpAppContainer from './containers/DhpAppContainer';

const routes = <Route path="/" component={DhpAppContainer} />;

export default routes;
